module.exports = __webpack_public_path__ + "img/sharp.d88b6ef9.png";